import type { ChipOwnerState, ChipSlot } from '@mui/joy/Chip/ChipProps';
import type { StyleOverrides, Theme } from '@mui/joy/styles';

export const getChipStyleOverrides = (): StyleOverrides<ChipSlot, ChipOwnerState, Theme> => {
  return {
    root: () => [{}],
    action: () => [
      {
        backgroundColor: 'unset',
        ':hover': {
          backgroundColor: 'unset',
        },
        border: 'none',
      },
    ],
  };
};
